<template>
    <div class="form-section mt-4 ms-4" v-if="superUser || canViewFnB">
      <!-- Container for title and button -->
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <h5 style="font-weight: bolder; color: #555555">F&B Extras Revenues</h5>
        </div>
        <div>
          <!-- Display the total sum of all total_revenue, with € symbol only if total is greater than 0 -->
          <h5 style="font-weight: bolder; color: #555555">
            ΣΥΝΟΛΟ: {{ formattedBudgetTotal }}
            <span v-if="budgetTotal"> €</span>
          </h5>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-start ">
      <!-- Title -->
    </div>

      <!-- Display list of revenue categories -->
      <div v-if="dateFromFormatted && dateToFormatted" class="mt-4 row">
        <div
          v-for="(revenue, index) in items"
          :key="revenue.id"
          class="col-md-11 card shadow-custom mb-3 bg-white rounded position-relative"
        >
          <!-- Non-Editable View -->
          <div v-if="!revenue.isEditing">
            <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
    <div class="col-md-8">
      <p class="label-with-circle">
        <strong>{{ revenue.restaurant_kind }}</strong>
      </p>
    </div>
    <div class="col-md-4 text-end">
      <p>
        <strong>Σύνολο Εσόδου:</strong> {{ formatNumber(revenue.total_fnb_revenues) }} €
      </p>
    </div><hr/><br>

  <!-- Table Section -->
  <div class="table-responsive mt-4">
    <table class="table table-bordered text-center">
      <thead class="table-dark">
        <tr>
          <th></th>
          <th v-for="revenueMonth in revenue.revenues" :key="revenueMonth.id">
            {{ getMonthName(revenueMonth.date_from) }}
          </th>
          <th>ΕΤΟΣ (ΣΥΝΟΛΟ)</th>
        </tr>
      </thead>
      <tbody>
                  <tr>
                    <td><strong>Available Room Nights</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'room-' + revenueMonth.id">
                      {{ formatNumber(revenueMonth.available_room_nights_per_month) }}
                    </td>
                    <td><strong>{{ calculateTotal(revenue.revenues, 'available_room_nights_per_month') }}</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Available Pax Nights</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'pax-' + revenueMonth.id">
                      {{ formatNumber(revenueMonth.available_pax_nights_per_month) }}
                    </td>
                    <td><strong>{{ calculateTotal(revenue.revenues, 'available_pax_nights_per_month') }}</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Monthly Occupancy (%)</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'occupancy-' + revenueMonth.id">
                      {{ formatNumber(revenueMonth.monthly_occupancy) }}
                    </td>
                    <td><strong>{{ calculateAverage(revenue.revenues, 'monthly_occupancy') }} (Μ.Ο.)</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Room Nights Sold</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'room-sold-' + revenueMonth.id">
                      {{ formatNumber(revenueMonth.room_nights_sold_per_month) }}
                    </td>
                    <td><strong>{{ calculateTotal(revenue.revenues, 'room_nights_sold_per_month') }} </strong></td>
                  </tr>
                  <tr>
                    <td><strong>Monthly Ratio Guest/Room</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'room-' + revenueMonth.id">
                      {{ revenueMonth.monthly_ratio }}
                    </td>
                    <td><strong>-</strong></td>
                  </tr>
                  <tr>
                    <td><strong>Pax Nights Sold</strong></td>
                    <td v-for="revenueMonth in revenue.revenues" :key="'pax-sold-' + revenueMonth.id">
                      {{ formatNumber(revenueMonth.pax_nights_sold_per_month) }}
                    </td>
                    <td><strong>{{ calculateTotal(revenue.revenues, 'pax_nights_sold_per_month') }}</strong></td>
                  </tr>
                </tbody>
    </table>
  </div>

  <!-- Monthly Supplement Pick Ups Section -->
<div class="col-md-12 align-items-center justify-content-center mt-4">
  <p>
    <strong>Μonthly Supplement Pick ups (%)</strong>
  </p>
</div>

<div class="table-responsive">
  <table class="table table-bordered text-center">
    <thead class="table-dark">
      <tr>
        <th></th>
        <th v-for="revenueMonth in revenue.revenues" :key="revenueMonth.id">
          {{ getMonthName(revenueMonth.date_from) }}
        </th>
        <th>ΕΤΟΣ (Μ.Ο.)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>BB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'bb-' + revenueMonth.id">
          {{ revenueMonth.monthly_supplement_pick_up_bb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'monthly_supplement_pick_up_bb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>HB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'hb-' + revenueMonth.id">
          {{ revenueMonth.monthly_supplement_pick_up_hb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'monthly_supplement_pick_up_hb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>FB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'fb-' + revenueMonth.id">
          {{ revenueMonth.monthly_supplement_pick_up_fb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'monthly_supplement_pick_up_fb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>AI</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'ai-' + revenueMonth.id">
          {{ revenueMonth.monthly_supplement_pick_up_ai }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'monthly_supplement_pick_up_ai') }}</strong></td>
      </tr>
    </tbody>
  </table>
</div>

<!-- F&B Extra Revenue/Guest Section -->
<div class="col-md-12 align-items-center justify-content-center mt-4">
  <p>
    <strong>F&B Extra Revenue/Guest (€)</strong>
  </p>
</div>

<div class="table-responsive">
  <table class="table table-bordered text-center">
    <thead class="table-dark">
      <tr>
        <th></th>
        <th v-for="revenueMonth in revenue.revenues" :key="revenueMonth.id">
          {{ getMonthName(revenueMonth.date_from) }}
        </th>
        <th>ΕΤΟΣ (Μ.Ο.)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>BB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-bb-' + revenueMonth.id">
          {{ revenueMonth.extra_revenue_per_guest_bb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'extra_revenue_per_guest_bb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>HB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-hb-' + revenueMonth.id">
          {{ revenueMonth.extra_revenue_per_guest_hb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'extra_revenue_per_guest_hb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>FB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-fb-' + revenueMonth.id">
          {{ revenueMonth.extra_revenue_per_guest_fb }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'extra_revenue_per_guest_fb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>AI</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-ai-' + revenueMonth.id">
          {{ revenueMonth.extra_revenue_per_guest_ai }}
        </td>
        <td><strong>{{ calculateAverage(revenue.revenues, 'extra_revenue_per_guest_ai') }}</strong></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="col-md-12 align-items-center justify-content-center mt-4">
  <p>
    <strong>F&B Extra Revenue (€)</strong>
  </p>
</div>

<div class="table-responsive">
  <table class="table table-bordered text-center">
    <thead class="table-dark">
      <tr>
        <th></th>
        <th v-for="revenueMonth in revenue.revenues" :key="revenueMonth.id">
          {{ getMonthName(revenueMonth.date_from) }}
        </th>
        <th>ΕΤΟΣ (ΣΥΝΟΛΟ)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>BB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-bb-' + revenueMonth.id">
          {{ formatNumber(revenueMonth.total_fnb_revenue_bb) }}
        </td>
        <td><strong>{{ calculateTotal(revenue.revenues, 'total_fnb_revenue_bb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>HB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-hb-' + revenueMonth.id">
          {{ formatNumber(revenueMonth.total_fnb_revenue_hb) }}
        </td>
        <td><strong>{{ calculateTotal(revenue.revenues, 'total_fnb_revenue_hb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>FB</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-fb-' + revenueMonth.id">
          {{ formatNumber(revenueMonth.total_fnb_revenue_fb) }}
        </td>
        <td><strong>{{ calculateTotal(revenue.revenues, 'total_fnb_revenue_fb') }}</strong></td>
      </tr>
      <tr>
        <td><strong>AI</strong></td>
        <td v-for="revenueMonth in revenue.revenues" :key="'extra-ai-' + revenueMonth.id">
          {{ formatNumber(revenueMonth.total_fnb_revenue_ai) }}
        </td>
        <td><strong>{{ calculateTotal(revenue.revenues, 'total_fnb_revenue_ai') }}</strong></td>
      </tr>
      <tr>
  <td><strong>Total Monthly F&B Revenue</strong></td>
  <td v-for="revenueMonth in revenue.revenues"  :key="'total-' + index">
    {{ calculateMonthlyFnbTotal(revenueMonth) }}
  </td>
  <td><strong>{{ calculateTotal(revenue.revenues, 'total_fnb_revenue') }}</strong></td>

</tr>

    </tbody>
  </table>
</div>

</div>



            <!-- Edit Button -->
            <div class="action-buttons">
              <button class="btn border-0 p-1 edit" @click="editItem(revenue)">
                <img src="../assets/images/edit-budget.png" alt="Edit" width="30" />
              </button>
            </div>
          </div>
  
          <!-- Editable View -->
          <div v-else>
    <div class="row align-items-center" style="color:#A6A6A6; font-weight:bolder">
      <div class="col-md-8">
        <p class="label-with-circle2">
        <strong style="color:black">{{ revenue.restaurant_kind }}</strong>
      </p>
      </div>
     
    </div>

    <div class="col-md-12 align-items-center justify-content-center mt-4">
      <p>
        <strong>Monthly Ratio Guest/Room</strong>
      </p>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
    <thead class="table-dark">
      <tr>
        <th></th>
        <th v-for="revenueMonth in revenue.revenues" :key="'header-ratio-' + revenueMonth.id">
          {{ getMonthName(revenueMonth.date_from) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><strong>Monthly Ratio Guest/Room:</strong></td>
        <td
          v-for="(revenueMonth, idx) in revenue.revenues"
          :key="'input-ratio-' + revenueMonth.id"
        >
          <input
            type="number"
            class="form-control"
            v-model.number="revenue.revenues[idx].monthly_ratio"
            placeholder="0.00"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>

     <div class="col-md-12 align-items-center justify-content-center mt-4">
      <p>
        <strong>Μonthly Supplement Pick Ups (%)</strong>
      </p>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="table-dark">
          <tr>
            <th></th>
            <th v-for="month in generatedMonths(revenue)" :key="month">
              {{ month }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="type in ['BB', 'HB', 'FB', 'AI']" :key="type">
            <td><strong>{{ type }}</strong></td>
            <td
  v-for="(month, index) in generatedMonths(revenue)"
  :key="type + '-' + index"
>
  <input
    type="text"
    :value="getSupplementData(revenue.revenues, month, type)" 
    class="form-control"
    @input="setSupplementData($event.target.value, month, type)" 
  />
</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-12 align-items-center justify-content-center mt-4">
      <p>
        <strong>F&B Extra Revenue/Guest (€)</strong>
      </p>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="table-dark">
          <tr>
            <th></th>
            <th v-for="month in generatedMonths(revenue)" :key="month">
              {{ month }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="type in ['BB', 'HB', 'FB', 'AI']" :key="type">
            <td><strong>{{ type }}</strong></td>
            <td
  v-for="(month, index) in generatedMonths(revenue)"
  :key="type + '-' + index"
>
  <input
    type="text"
    :value="getExtraRevenueData(revenue.revenues, month, type)" 
    class="form-control"
    @input="setExtraRevenueData($event.target.value, month, type)" 
  />
</td>

          </tr>
        </tbody>
      </table>
      </div> 
      <div class="row form-actions mt-4">
        <div class="d-flex justify-content-end">
          <button class="btn btn-secondary justify-content-end align-items-end"
                  @click="cancelEdit(revenue)">
                  ΑΚΥΡΩΣΗ
          </button>
        </div>
      </div>
       <!-- Form Actions -->
      <div class="action-buttons">
        <button class="btn border-0 p-1 save" @click="confirmSaveItem(index)">
          <img src="../assets/images/save.png" alt="Save" width="30" />
        </button>
      </div>
    </div>
    </div> 
  </div>
</div>
  </template>
  
  <script>
  import { useHead } from '@vueuse/head';
  import { getFnbExtrasRevenues, updateFnbExtrasRevenues } from '@/services/FnbExtrasRevenue';
  import { useToast } from 'vue-toastification';
  import { fetchBudgetInfo, fetchUsers, changeUser, fetchUserInfo } from '../services/user';
  import { getBudget, updateHotelPeriod } from "@/services/budget";
  import dayjs from 'dayjs';
  import { mapActions } from 'vuex';
  import { mapGetters } from 'vuex';
  
  export default {
  name: 'F&B Extras Revenues',
  methods: {
   
   ...mapActions(['fetchUserData']),

 },
 computed: {
   ...mapGetters({
     getUserPermission: 'getUserPermission',
     getSuperUserPermission: 'getSuperUserPermission',
     getUserRoles: 'getUserRoles'

   }),

totalBB() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.monthly_supplement_pick_up_bb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalHB() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.monthly_supplement_pick_up_hb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalFB() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.monthly_supplement_pick_up_fb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalAI() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.monthly_supplement_pick_up_ai || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalBBExtra() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.extra_revenue_per_guest_bb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalHBExtra() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.extra_revenue_per_guest_hb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalFBExtra() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.extra_revenue_per_guest_fb || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},
totalAIExtra() {
  const total = this.revenue.revenues.reduce((sum, month) => sum + (month.extra_revenue_per_guest_ai || 0), 0);
  return Number.isFinite(total) ? total.toFixed(0) : '0';
},

   superUser() {
           return this.getSuperUserPermission === 1;
       },
       canViewSales() {
           return this.getUserRoles.includes(1);
       },
   canViewFnB() {
           return this.getUserRoles.includes(2);
       },
       canViewHR() {
           return this.getUserRoles.includes(3);
       },
       canViewOperational() {
           return this.getUserRoles.includes(4);
       },
       formattedBudgetTotal() {
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(this.budgetTotal);
    },
 },
  data() {
    return {
      showForm: false,
      form: {
        title: '',
        description: '',
      },
      revenue: {
        date_from: null,
        date_to: null,
        revenues: [],
      },
      items: [],
      currentEditRevenue: null,
      budgetTotal: 0,
      budgetYear: null,  
      dateFrom: null,
      dateΤο: null,
      editableDateFrom: null,
      editableDateΤο: null,
      dateFromFormatted: null,
      dateToFormatted: null,
      months: [],

    };
  },



  watch: {
    'revenue.date_from'(newStartDate) {
      this.updateMonths();
    },
    'revenue.date_to'(newEndDate) {
      this.updateMonths();
    },
  },

  methods: {
   
    ...mapActions(['fetchUserData']),

formatNumber(value) {
  if (value == null || isNaN(value)) return '0';
      return new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    },

getMonthName(dateStr) {
  return dayjs(dateStr).format('MMMM');
},

calculateTotal(arr, key) {
  const total = arr.reduce((sum, month) => sum + (month[key] || 0), 0);
  return this.formatNumber(total);
},

calculateAverage(arr, key) {
  const total = arr.reduce((sum, month) => sum + (month[key] || 0), 0);
  const avg = arr.length ? total / arr.length : 0;
  return this.formatNumber(avg);
},
calculateMonthlyFnbTotal(revenueMonth) {
  const types = ['BB', 'HB', 'FB', 'AI'];
  let total = 0;

  total = revenueMonth.total_fnb_revenue_bb + revenueMonth.total_fnb_revenue_hb + revenueMonth.total_fnb_revenue_fb + revenueMonth.total_fnb_revenue_ai;

  return this.formatNumber(total);
},



    replaceCommasWithDots(obj) {
        // Loop through each key in the object
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
              // Check if the value is a string and looks like a float with comma as decimal separator
              if (typeof obj[key] === 'string' && obj[key].match(/^\d{1,3}(.\d{3})*,\d+$/)) {
                  // Replace the thousand separators (.) and convert comma to dot for decimals
                  obj[key] = parseFloat(obj[key].replace(/\./g, '').replace(',', '.'));
              }
            }
        }
        return obj;
    },

    // Generate month names based on date_from and date_to
    generatedMonths(revenue) {
      return this.calculateMonthNames(revenue.date_from, revenue.date_to);
    },

    // Update months list when date range changes
    updateMonths() {
      this.months = this.calculateMonthNames(this.revenue.date_from, this.revenue.date_to);
      console.log('Updated months:', this.months);  // For debugging
    },

    // Calculate the month names between two dates
    calculateMonthNames(startDate, endDate) {
      const months = [];
      if (startDate && endDate) {
        let start = new Date(startDate);
        const end = new Date(endDate);

        // Loop through each month and push its name to the array
        while (start <= end) {
          months.push(new Intl.DateTimeFormat("el-GR", { month: "long" }).format(start));
          start.setMonth(start.getMonth() + 1);
        }

        // Ensure the last month is included even if not in the initial range
        const lastMonth = new Date(endDate);
        if (months[months.length - 1] !== new Intl.DateTimeFormat("el-GR", { month: "long" }).format(lastMonth)) {
          months.push(new Intl.DateTimeFormat("el-GR", { month: "long" }).format(lastMonth));
        }

        console.log("Months:", months);
      }
      return months;
    },


    // Ensure data is initialized for all months, even the last one (e.g., July)
    initializeMonthData() {
      this.months.forEach((month) => {
        if (!this.revenue.revenues[month]) {
          this.revenue.revenues[month] = {
            extra_revenue_per_guest_ai: null,
            extra_revenue_per_guest_bb: null,
            extra_revenue_per_guest_fb: null,
            extra_revenue_per_guest_hb: null,
            monthly_supplement_pick_up_ai: null,
            monthly_supplement_pick_up_bb: null,
            monthly_supplement_pick_up_fb: null,
            monthly_supplement_pick_up_hb: null,
          };
        }
      });
    },

    // Get the supplement data for a specific month and type
    getSupplementData(revenues, month, type) {
      if (!revenues || revenues.length === 0) return null;
      const revenueData = revenues.find((rev) => this.getMonthName(rev.date_from) === month);
      return revenueData ? revenueData[`monthly_supplement_pick_up_${type.toLowerCase()}`] : null;
    },

    // Get extra revenue data for a specific month and type
    getExtraRevenueData(revenues, month, type) {
      if (!revenues || revenues.length === 0) return null;
      const revenueData = revenues.find((rev) => this.getMonthName(rev.date_from) === month);
      return revenueData ? revenueData[`extra_revenue_per_guest_${type.toLowerCase()}`] : null;
    },

   // Set supplement data for a specific month and type
setSupplementData(value, month, type) {
  // Convert commas to dots before assigning the value
  value = this.replaceCommasWithDots({ temp: value }).temp;

  const revenueData = this.revenue.revenues.find(
    (rev) => this.getMonthName(rev.date_from) === month
  );

  if (revenueData) {
    revenueData[`monthly_supplement_pick_up_${type.toLowerCase()}`] = value;
  }

  this.handleMonthDataChange(month, type, value);
},

// Set extra revenue data for a specific month and type
setExtraRevenueData(value, month, type) {
  // Convert commas to dots before assigning the value
  value = this.replaceCommasWithDots({ temp: value }).temp;

  const revenueData = this.revenue.revenues.find(
    (rev) => this.getMonthName(rev.date_from) === month
  );

  if (revenueData) {
    revenueData[`extra_revenue_per_guest_${type.toLowerCase()}`] = value;
  }

  this.handleMonthDataChange(month, type, value);
},


    // Get the month name for a specific date
    getMonthName(date) {
      return new Intl.DateTimeFormat("el-GR", { month: "long" }).format(new Date(date));
    },

    // Handle data change for a specific month
    handleMonthDataChange(month, type, value) {
      if (!this.revenue.revenues[month]) {
        this.revenue.revenues[month] = {};
      }
      this.revenue.revenues[month][type] = value;
    },

    // Fetch the list of revenue items from the API
    async fetchItems() {
      try {
        const response = await getFnbExtrasRevenues(this.$route.params.budget_id);
        this.items = response.data.map((item) => ({ ...item, isEditing: false }));
        if (this.items.length > 0) {
          this.revenue = this.items[0]; // Use the first item
        }
        this.initializeMonthData(); // Ensure all months are initialized
      } catch (error) {
        console.error('Error fetching fnb revenues:', error);
      }
    },

    // Fetch the total budget revenue
    async fetchBudgetInfoData() {
  try {
    const response = await fetchBudgetInfo(this.$route.params.budget_id);

    if (response && response.data && response.data.data) {
      this.budgetTotal = response.data.data.total_fnb_revenues || 0;

      // Convert raw dates using dayjs to avoid time zone adjustments
      this.dateFrom = response.data.data.date_from
        ? dayjs(response.data.data.date_from).format('YYYY-MM-DD')
        : null;
      this.dateTo = response.data.data.date_to
        ? dayjs(response.data.data.date_to).format('YYYY-MM-DD')
        : null;

      // Assign formatted dates for display purposes
      this.dateFromFormatted = response.data.data.date_from_formatted || null;
      this.dateToFormatted = response.data.data.date_to_formatted || null;

      // Extract the year
      this.budgetYear = dayjs(response.data.data.year).year();

    }
  } catch (error) {
    console.error('Failed to fetch budget info:', error);
  }
},



updateDateFrom() {
    // This ensures "To" input only allows dates after the selected "From" date
    if (this.editableDateTo && this.editableDateFrom > this.editableDateTo) {
      this.editableDateTo = this.editableDateFrom;
    }
  },

  disableInvalidDates(date) {
    const year = dayjs(date).year();
    return year === this.budgetYear;
  },
    // Start editing a specific revenue item
    editItem(revenue) {
      this.currentEditRevenue = revenue;
      revenue.isEditing = true;
    },

    // Cancel editing
    cancelEdit(revenue) {
      revenue.isEditing = false;
      this.currentEditRevenue = null;
    },

    // Save the updated item via API
    async confirmSaveItem(index) {
      try {
        const revenue = this.items[index];
        const payload = {
  date_from: revenue.date_from,
  date_to: revenue.date_to,
  monthly_ratio: this.formatMonthlyData(revenue.revenues, 'monthly_ratio'), // ✅ FIXED HERE
  monthly_supplement_pick_up_bb: this.formatMonthlyData(revenue.revenues, 'monthly_supplement_pick_up_bb'),
  monthly_supplement_pick_up_hb: this.formatMonthlyData(revenue.revenues, 'monthly_supplement_pick_up_hb'),
  monthly_supplement_pick_up_fb: this.formatMonthlyData(revenue.revenues, 'monthly_supplement_pick_up_fb'),
  monthly_supplement_pick_up_ai: this.formatMonthlyData(revenue.revenues, 'monthly_supplement_pick_up_ai'),
  extra_revenue_per_guest_bb: this.formatMonthlyData(revenue.revenues, 'extra_revenue_per_guest_bb'),
  extra_revenue_per_guest_hb: this.formatMonthlyData(revenue.revenues, 'extra_revenue_per_guest_hb'),
  extra_revenue_per_guest_fb: this.formatMonthlyData(revenue.revenues, 'extra_revenue_per_guest_fb'),
  extra_revenue_per_guest_ai: this.formatMonthlyData(revenue.revenues, 'extra_revenue_per_guest_ai'),
};

        // Send the payload to the backend
        const response = await updateFnbExtrasRevenues(revenue.id, payload);

        if (response.success) {
          useToast().success('Changes saved successfully');
        } else {
          useToast().error('Failed to save changes');
        }

        // End editing mode and refresh data
        revenue.isEditing = false;
        this.fetchItems();
        this.fetchBudgetInfoData();
      } catch (error) {
        console.error('Error saving revenue:', error);
      }
    },

    // Format the monthly data
    formatMonthlyData(revenues, field) {
      const formattedData = {};
      revenues.forEach((revenue) => {
        const month = new Date(revenue.date_from).getMonth() + 1; // Get the month (1-indexed)
        formattedData[month] = revenue[field] || null;
      });
      return formattedData;
    },
  },

  mounted() {
    this.fetchItems();
    this.fetchBudgetInfoData();
    useHead({
      title: 'F&B Extras Revenues',
      meta: [
        { name: 'description', content: 'Manage F&B extras revenues for outlets' },
      ],
    });
  },
};
</script>


  <style scoped>
  .form-container {
   background: #f8f9fa;
   padding: 20px;
   border-radius: 8px;
   border: 1px solid #ddd;
 }
 
 .card {
   padding: 15px;
   background: #fff;
   border-radius: 8px;
   border: 1px solid #ddd;
   position: relative;
   margin-left:35px;
 }
 
 .action-buttons {
   position: absolute;
   top: 100px;
   right: 10px;
 }
 
 
 
 hr {
   margin: 10px 0;
 }
 
 .modal-backdrop {
   opacity: 0.5 !important;
 }
 /* Adding a circle bullet point next to each label */
 .label-with-circle::before {
   content: '';
   display: inline-block;
   width: 10px;
   height: 10px;
   background-color: #A6A6A6;
   border-radius: 50%;
   margin-right: 10px;
   vertical-align: middle;
 }
 
 .label-with-circle2::before {
   content: '';
   display: inline-block;
   width: 10px;
   height: 10px;
   background-color: var(--primary-color);
   border-radius: 50%;
   margin-right: 10px;
   vertical-align: middle;
   color:black;
 }
 /* Aligning middle elements like Basic Board and Supplement */
 .align-middle {
   margin-top: 30px; /* Adjust this value based on the spacing you want */
 }
 
 /* Custom shadow for outlet-card */
 .shadow-custom {
   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
   transition: box-shadow 0.3s ease-in-out;
 }
 
 .shadow-custom:hover {
   box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 12px 40px rgba(0, 0, 0, 0.2);
 }
 
 
 
 .edit{
   position: absolute;
 
   top: 25%; /* Adjust the vertical position to be slightly above middle */
   right: -30px; /* Half the button outside the outlet-card */
   transform: translateY(-150%); /* Center vertically relative to its position */
 
 }
 
 .save {
   position: absolute;
   top: 30%; /* Adjust as needed to lower the button */
   right: -18px; /* Adjust to move outside the card */
   transform: translateY(-170%); /* Further adjust for desired position */
 }
 
 .delete {
   position: absolute;
   top: 50%; /* Adjust to position higher or lower */
   right: -18px; /* Same as above */
   transform: translateY(30%); /* Further adjust for desired position */
 
 }

 .custom-action-buttons {
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-172%);
  background: #67B662;
  width: 40px;
  height: 40px;
}

.custom-action-buttons:hover {
  position: absolute;
  top: 50%;
  right: -20px;
  transform: translateY(-172%);
  background: #67B662;
  width: 40px;
  height: 40px;
}
 </style>
 
